module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInDown"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Авторизирую..."
    }
  }) : _c('form', {
    staticClass: "col-lg-5 col-md-8 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleLoginFormSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Войти в Аларм План")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Войдите в свой аккаунт")]), _vm._v(" "), _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error || _vm.$v.login.email.$error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.email),
      expression: "login.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "required": "",
      "autofocus": "",
      "placeholder": "Электронная почта"
    },
    domProps: {
      "value": (_vm.login.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "email", $event.target.value)
      }, function($event) {
        _vm.$v.login.email.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Ошибка авторизации")]) : _vm._e(), _vm._v(" "), (_vm.$v.login.email.$error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Укажите валидный адрес электронной почты")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error || _vm.$v.login.password.$error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "required": "",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }, function($event) {
        _vm.$v.login.password.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Неправильный email или пароль")]) : _vm._e(), _vm._v(" "), (_vm.$v.login.password.$error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Пароль должен быть не менее 6 символов")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-1"
  }, [_c('label', {
    staticClass: "switch switch-text switch-primary-outline-alt mr-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.remember),
      expression: "login.remember"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.login.remember) ? _vm._i(_vm.login.remember, null) > -1 : (_vm.login.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.login.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.login.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.login.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.login, "remember", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n                        Запомнить меня\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    class: {
      'disabled': _vm.$v.login.$invalid
    },
    attrs: {
      "disabled": _vm.$v.login.$invalid,
      "type": "submit"
    }
  }, [_vm._v("Войти")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RemindPassword'
      }
    }
  }, [_vm._v("Забыли пароль?")])], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1e53030d"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/Login.vue
// module id = 1006
// module chunks = 1